import { Link } from "react-router-dom";

// Brand logo — uses PNG assets processed from the uploaded webp.
// Native artwork ratio is 3028 × 418 (≈ 7.24:1). Always preserved by width:auto + shrink-0.
// variant="brand" → blue letters on transparent bg (for light surfaces)
// variant="light" → white letters on transparent bg (for dark surfaces)

export function JackstoneLogo({ className = "h-8 w-auto", variant = "brand" }) {
  const src =
    variant === "light" ? "/jackstone-logo-white.png" : "/jackstone-logo.png";
  return (
    <img
      src={src}
      alt="Jackstone"
      width={3028}
      height={418}
      className={`${className} max-w-none shrink-0 object-contain`}
    />
  );
}

// Clickable logo that routes back to the dashboard. Use in app chrome/navigation.
export function JackstoneLogoLink({ to = "/dashboard", ...props }) {
  return (
    <Link
      to={to}
      data-testid="brand-home-link"
      aria-label="Jackstone — go to dashboard"
      className="inline-block"
    >
      <JackstoneLogo {...props} />
    </Link>
  );
}

export function JackstoneMark({ className = "h-8 w-8" }) {
  return <img src="/favicon.png" alt="Jackstone" className={className} />;
}
